<!-- 数据判断规则设置 == 数据判断规则设置明细表 -->
<template>
  <div>
    <Table
      ref="table"
      :loadObj='{}'
      :option="{}"
      :colObj='{
        opId:"3301",
        name:"数据判断规则设置明细表",
        parentId:"RULE_ID",
        parentName:"数据判断规则设置",
        parentPath:"/system/judgeRule",
        parentQuery:{
        },
        addForm:{
        },
        dataClass:2,
        col:[]
      }'
    >
    </Table>
  </div>
</template>

<script>
import Table from '@/components/table/dataTablecSon';
export default {
  components: {
    Table
  },
  data() {
    return {
      firstEnter:true,
    };
  },
  computed: {
  },
  methods: {
  },
  created(){
  },
  activated(){
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  }
};
</script>

<style></style>